module.exports = new __parcel__URL__("cross-join-folder.39b6d302.svg").toString();